import React from 'react';
import './Contact.css';
import { useMobileDetection } from '../hooks/useMobileDetection';
import LogoNav from '../components/Navigation/LogoNav';

const Contact: React.FC = () => {
  const { isMobile, isTablet } = useMobileDetection();
  const useMobileLayout = isMobile || isTablet;

  return (
    <div className="contact-page" style={{
      minHeight: '100vh',
      backgroundColor: '#f8fafc',
      paddingTop: useMobileLayout ? '60px' : '80px'
    }}>
      {!useMobileLayout && <LogoNav />}
      <div style={{ maxWidth: '800px', margin: '0 auto', padding: '40px 20px' }}>
        <div className="contact-card" style={{
          backgroundColor: 'white',
          padding: '48px',
          borderRadius: '16px',
          boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1)',
          border: '1px solid #f1f5f9'
        }}>
          <div style={{ textAlign: 'left', marginBottom: '24px' }}>
            <h1 className="contact-title" style={{ fontSize: '32px', fontWeight: 600, color: '#1f2937', margin: 0 }}>Contact Us</h1>
            <p className="contact-subtitle" style={{ color: '#6b7280', marginTop: '8px' }}>
              Have questions about our products or need a hand? We’re here to help.
            </p>
          </div>

          <div className="contact-section">
            <h2 className="contact-heading">Get in Touch</h2>
            <p className="contact-text">
              Email us at <a href="mailto:support@zoningpal.com">support@zoningpal.com</a>
            </p>
            <p className="contact-note">We typically respond within 24 hours on business days.</p>
          </div>

          <div className="contact-smallprint" style={{ marginTop: '20px' }}>
            Looking for policies or terms? Visit the Legal page for privacy and terms information.
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;

